// extracted by mini-css-extract-plugin
module.exports = {"SliderArrow":"styles_SliderArrow__XXzdq","arrowIcon":"styles_arrowIcon__bhZ5T"};